// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ph-0";
export var leftAlign = "_ph-4";
export var listItem = "_ph-2";
export var listItemWrapper = "_ph-1";
export var operationText = "_ph-3";